import { config } from "../config";

/**
 * Get the base URL for the QPilot Recipes API
 * Uses the standard backend host - recipes endpoints are at /recipes/*
 *
 * @returns {string} The API base URL
 */
export function getRecipesApiUrl() {
    return config.REACT_APP_BACKEND_HOST;
}

// Applied-state facts control verification presentation. Backend prose belongs
// in the editor's Advanced reasoning disclosure, not a transient notification.
export const APPLIED_AND_CLEAR = "applied_and_clear";

/**
 * Notification severity follows the saved verification facts. A successful write
 * alone does not establish that the recipe is verified.
 *
 * @param {object|null|undefined} appliedState the server's `applied_state`
 * @returns {"success"|"warning"|"info"}
 */
export function appliedSeverity(appliedState) {
    if (appliedState?.still_needs_work) return "warning";
    return appliedState?.state === APPLIED_AND_CLEAR ? "success" : "info";
}
